export default __webpack_public_path__ + "/dist/images/img-1.png";